import { useRouter } from 'next/router';
import React, { FC, useEffect } from 'react';
import { RedirectType } from '../../../models/redirect-type';
import LoadingSpinner from '../../atoms/loading-spinner/loading-spinner';

const Redirect: FC<RedirectType> = ({ url }: RedirectType) => {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    router.replace(url);
  }, [router.isReady]);

  return <LoadingSpinner className="h-96" />;
};

export default Redirect;
